import Vue from 'vue';

export const BUS_EVENTO = new Vue();
